import EventBus from "./eventBus";
import { Howl, Howler } from "howler";

// check mobile OS, specifically needed for iOS to give the correct install msg
function getMobileOS() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }
  if (/android/i.test(userAgent)) {
    return "Android";
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }
  return "unknown or not mobile";
}

// check if running as full screen PWA, in which case don't prompt download
function isStandalone() {
  if (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone ||
    document.referrer.includes("android-app://")
  ) {
    return true; // console.log("This is running as standalone."); // i.e. pwa
  }
  if (getMobileOS() === "Android") return true; // hack to not show for android app...or any android device
  if (window.location.hostname.includes("ios.tuk")) return true;
  return false; // console.log("App is not running as standalone"); // not pwa
}

function isWebview() {
  if (navigator.platform.substr(0, 2) === "iP") {
    // iOS detected
    if (window.webkit && window.webkit.messageHandlers) return true;
  }
  return false;
}

function hasCameraAccess(callback) {
  let md = navigator.mediaDevices;
  if (!md || !md.enumerateDevices) return callback(false);
  md.enumerateDevices().then((devices) => {
    callback(devices.some((device) => "videoinput" === device.kind));
  });
}
// navigator.getMedia = (navigator.getUserMedia || // use the proper vendor prefix
//     navigator.webkitGetUserMedia ||
//     navigator.mozGetUserMedia ||
//     navigator.msGetUserMedia);
// navigator.getMedia({ video: false }, () => return false, () => return true);

// redirect path should be name of view route like /tuktuk,
// the leading slash is required, this.$router.currentRoute.path
function lineLogin(redirectPath) {
  // this.$cookies.set("line_login_attempted", true)
  // EventBus.$emit("LINE_LOGIN_ATTEMPT", null);
  EventBus.$emit("DEBUG", "LINE Login attempted");
  var channelID = "1616017577"; // should read from env
  var redirect = import.meta.env.VITE_HOST + redirectPath;
  var url = new URL("https://access.line.me/oauth2/v2.1/authorize");
  var query_string = url.search;
  var search_params = new URLSearchParams(query_string);
  search_params.set("response_type", "code");
  search_params.set("client_id", channelID);
  search_params.set("redirect_uri", redirect);
  search_params.set("state", "12345abcde");
  search_params.set("scope", "openid profile"); // could add email too
  search_params.set("bot_prompt", "aggressive"); // aggressive or normal
  url.search = search_params.toString();
  var loginURL = url.toString();
  console.log("LINE login redirect:", redirect, loginURL);
  window.location = loginURL;
}

// call this function to alert if your internet is slower than expected
function checkInternet(isLoading) {
  if (isLoading) {
    alert("Your internet seems a bit slow...");
    console.log("check your internet! it seems a bit slow...");
  } else {
    console.log("your internet speed looks good");
  }
}

// should call this if an API call determines it's necessary
function clearCache() {
  caches.keys().then(function(names) {
    for (let name of names) caches.delete(name);
  });
  forceSWupdate();
}

function forceSWupdate() {
  console.log("forceSWupdate");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.update();
      }
    });
  }
}

// keeps some of the cookies << should fix this since not using cookies anymore
function logout(cookies) {
  cookies.keys().forEach((k) => {
    if (!["uuid", "super"].includes(k)) cookies.remove(k);
  });
  var keep = ["uuid", "super"];
  Object.keys(localStorage).forEach((k) => {
    if (!keep.includes(k)) localStorage.removeItem(k);
  });
  EventBus.$emit("LOGOUT", null); // triggers swal and reload
}

// enable vibration support, if available vibrate
function vibrate() {
  navigator.vibrate =
    navigator.vibrate ||
    navigator.webkitVibrate ||
    navigator.mozVibrate ||
    navigator.msVibrate;
  if (navigator.vibrate) {
    navigator.vibrate([500, 300, 100]);
  }
}

// sounds list
function sounds(soundName, isVibrate) {
  var map = {
    fallback: "/sounds/bird_squawk.mp3", //"/sounds/wahwah.wav", << sound file too big
    parrot: "/sounds/parrot.mp3",
    money: "/sounds/kaching.mp3",
    safe: "/sounds/magic_wand.mp3",
    unsafe: "/sounds/unsafe.mp3",
    squawk: "/sounds/bird_squawk.mp3",
    sawatdii: "/sounds/sawatdii.mp4",
    mingalaba: "/sounds/mingalaba.mp3",
    servo: "/sounds/servo.mp3",
    navigate1: "/sounds/navigate1.mp3",
    navigate2: "/sounds/navigate2.mp3",
    success: "/sounds/success.mp3",
    mystery_short: "/sounds/mystery_short.mp3",
    mystery_long: "/sounds/mystery_long.mp3",
    collect1: "/sounds/collect1.mp3",
    collect2: "/sounds/collect2.mp3",
    collect3: "/sounds/collect3.mp3",
  };
  var thisSound = map[soundName];
  if (!thisSound) thisSound = map["fallback"]; // if no key soundName use fallback
  var sound = new Howl({ src: [thisSound] });
  Howler.volume(1.0);
  sound.play();
  if (isVibrate) vibrate();
}

// used to debounce action calls, e.g. createTransaction
// to ensure duplicate transactions aren't made by client
function debounce(commit, state, action, seconds) {
  if (state.timestamps[action]) {
    var diff = (new Date() - new Date(state.timestamps[action])) / 1000;
    if (diff < seconds) return true; // DEBOUNCE
  }
  commit("setTimestamp", action); // update action timestamp
  return false; // OKAY
}

export {
  getMobileOS,
  isStandalone,
  isWebview,
  hasCameraAccess,
  lineLogin,
  checkInternet,
  clearCache,
  logout,
  vibrate,
  sounds,
  debounce,
};
